import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M45.4129 24.32C45.4129 21.4924 47.7051 19.2002 50.5326 19.2002H58.8729C61.7004 19.2002 63.9926 21.4924 63.9926 24.32V58.8783C63.9926 61.7058 61.7004 63.998 58.8729 63.998H50.5326C47.7051 63.998 45.4129 61.7059 45.4129 58.8783V24.32Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7037 5.12091C22.7037 2.29335 24.9959 0.00115967 27.8235 0.00115967H36.1637C38.9912 0.00115967 41.2834 2.29335 41.2834 5.12091V58.8783C41.2834 61.7058 38.9912 63.998 36.1637 63.998H27.8235C24.9959 63.998 22.7037 61.7058 22.7037 58.8783V5.12091Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.11487 8.53418H13.4551C16.2827 8.53418 18.5749 10.8264 18.5749 13.6539V58.8784C18.5749 61.706 16.2827 63.9981 13.4551 63.9981H5.11487C2.28731 63.9981 -0.00488281 61.706 -0.00488281 58.8784V13.6539C-0.00488281 10.8264 2.28731 8.53418 5.11487 8.53418Z",
			fill: "#60A5FA"
		})
	]
});
export default SvgBarChart;
